import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import { ChangeStoreVariant } from './change-store-types';
import { computed, ref } from 'vue';
import { IStoreWithStock } from 'JS/types/Inventory';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreInfoCard',
  props: {
    variant: { default: 'store' },
    storeStatus: null,
    desiredQty: null,
    isCurrentStore: { type: Boolean },
    googleApiKey: null
  },
  emits: ["update-store"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'update-store', storeNum: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: ChangeStoreVariant, storeStatus: IStoreWithStock, desiredQty?: number, isCurrentStore: boolean, googleApiKey: string }






const store = computed(() => {
	return props.storeStatus.store;
});

const inventory = computed(() => {
	return props.storeStatus.inventory;
});

const storeHours = computed(() => {
	return  Object.entries(props.variant === 'store' ? store.value.hours : store.value.autoHours);
});

const phoneDigits = computed(() => {
	const retPhone = props.variant === 'store' ? store.value.phone : store.value.autoCenterPhone;
	return retPhone.replace(/\D/g,'');
});

const notCarried = computed(() => {
	return !inventory.value?.isStocked;
});

const outOfStock = computed(() => {
	return inventory.value?.netOnHand < 1;
});

const hasEnoughForDesiredQty = computed(() => {
	return props.desiredQty && inventory.value?.netOnHand > props.desiredQty && inventory.value?.netOnHand > 10;
});

const isExpanded = ref(false);

function handleCardExpand() {
	isExpanded.value = !isExpanded.value;
}


return { __sfc: true,props, emit, store, inventory, storeHours, phoneDigits, notCarried, outOfStock, hasEnoughForDesiredQty, isExpanded, handleCardExpand, Icon, LinkButton, TransitionExpand }
}

})